module.exports = __webpack_public_path__ + "img/app4.d3799121.jpg";